import { useMemo } from "react";

export function useMediaUrl(relativePath: string | null) {
  return useMemo(() => {
    if (!relativePath) return "";
    if (relativePath.startsWith("/cashier/files/")) return `/api${relativePath}`;
    if (relativePath.startsWith("/")) return relativePath;
    return `/api/cashier/files/${relativePath}`;
  }, [relativePath]);
}
